export default __webpack_public_path__ + "static/media/AlarmConsumptionSet1.cef0cadf.png";